import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import type { RouteResource } from '@townsquare/router/resources/types';
import type { ResourceContext } from '@townsquare/router/types';

import useUserHasCapabilitiesQuery, {
	useUserHasCapabilitiesQuery as useUserHasCapabilitiesQueryType,
} from './__generated__/useUserHasCapabilitiesQuery.graphql';

export const capabilityProviderResource: RouteResource<
	PreloadedQuery<useUserHasCapabilitiesQueryType, Record<string, unknown>>
> = createRelayResource<useUserHasCapabilitiesQueryType>({
	getQuery: (_, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const isValidWorkspace =
			Boolean(context.workspace?.cloudId) && Boolean(context.workspace?.organisationId);

		return {
			query: useUserHasCapabilitiesQuery,
			variables: {
				isValidWorkspace,
				context: {
					orgId: context.workspace?.organisationId ?? '',
					cloudId: context.workspace?.cloudId,
				},
			},
			maxAge: 60_000 * 30, // 30 minutes cache during the SPA session
		};
	},
});
